const e164Regex = /^\+[1-9]\d{1,14}$/;
const rawFrenchMobileRegex = /^0[67]\d{8}$/;
const frenchE164MobileRegex = /^\+33[67]\d{8}$/;
const frenchE164MobileRegexWith0 = /^\+330[67]\d{8}$/;
const plus33Regex = /^\+33/;
export function parseMobileNumberAsE164(input) {
    const cleaned = input.replace(/[\s\.\(\)]/g, "");
    if (plus33Regex.test(cleaned)) {
        if (frenchE164MobileRegex.test(cleaned)) {
            return cleaned;
        }
        if (frenchE164MobileRegexWith0.test(cleaned)) {
            return `+33${cleaned.slice(4)}`;
        }
        throw new Error("Invalid phone number");
    }
    if (rawFrenchMobileRegex.test(cleaned)) {
        return `+33${cleaned.slice(1)}`;
    }
    if (e164Regex.test(cleaned)) {
        return cleaned;
    }
    throw new Error("Invalid phone number");
}
const ddnRegex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
const reversedDDNRegex = /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/;
export function parseDDNStringAsDDN(input) {
    const cleaned = input.replace(/-/g, "/");
    if (reversedDDNRegex.test(cleaned)) {
        const [year, month, day] = cleaned.split("/");
        return `${day}/${month}/${year}`;
    }
    if (!ddnRegex.test(cleaned)) {
        throw new Error("Invalid date");
    }
    return cleaned;
}
export function parserToValidator(parser) {
    return (input) => {
        try {
            parser(input);
            return true;
        }
        catch (e) {
            return false;
        }
    };
}
//# sourceMappingURL=parsers.js.map